import script from "./MenuMainItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuMainItem.vue?vue&type=script&setup=true&lang=js"

import "./MenuMainItem.vue?vue&type=style&index=0&id=3128aff4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3128aff4"]])

export default __exports__